import styled from "styled-components";

export const ContainerMain = styled.div<{ $open: Boolean }>`
  display: flex;
  flex: 1;
  overflow-y: hidden;
  position: relative;
  grid-area: main;
  transition: all .3s ease-in;
`;
